var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ml-3 SlcListSelection-creationBtn",on:{"click":function($event){$event.stopPropagation();return _vm.openModal.apply(null, arguments)}}},[_vm._v("\n  "+_vm._s(_vm.$t("createNewList"))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }